import formatPrice from '../helpers/formatPrice';

const $shippingSelectors = $('.js-shipping-methods-output');
const $otherAddressCheckbox = $('.js-delivery-address-check');
const $otherAddress = $('.js-delivery-address');
const $summaryDelivery = $('.js-summary-delivery');
const $summaryTotal = $('.js-summary-total');
const $summarySubtotal = $('.js-summary-subtotal');
const $summaryDiscount = $('.js-summary-discount');
const $myParcelMessage = $('.js-my-parcel-message');
const $myParcelLocations = $('.js-my-parcel-locations');
const $myParcelStreetCityFieldsPreview = $('.js-my-parcel-street-city-fields-preview');
const $myParcelHouseNumber = $('.js-parcel-house-number');
const $myParcelPostalCode = $('.js-parcel-postal-code');

const SHIPPING_SELECTOR = '.js-shipping-selector';

const shippingSelector = {
  initialize() {
    if ($shippingSelectors.length) {
      this.createEvents();
    }
  },

  createEvents() {
    $shippingSelectors.on('change', SHIPPING_SELECTOR, ({ target }) => {
      // Hide extra text for my parcel
      $myParcelMessage.hide();
      $myParcelStreetCityFieldsPreview.hide();
      $myParcelLocations.find('.is-active').removeClass('is-active');

      const subtotal = parseFloat($summarySubtotal.data('subtotal-costs'));
      const discount = parseFloat($summaryDiscount.data('summary-discount'));
      const shippingCosts = parseFloat($(target).data('shipping-costs'));

      if ($(target).hasClass('js-shipping-pickup')) {
        $otherAddressCheckbox[0].checked = false;
        $otherAddress.toggle($otherAddressCheckbox[0].checked);
        $summaryDelivery.html(formatPrice(0));
        this.showSummaryShippingCosts();
      } else {
        this.emptyValues();

        if (!$(target).hasClass('js-shipping-my-parcel')) {
          this.emptyMyParcelValues();
        }
      }

      $summaryDelivery.html(formatPrice(shippingCosts));
      this.showSummaryShippingCosts();

      let total = subtotal + shippingCosts;

      if (!Number.isNaN(discount) && discount > 0) {
        total -= discount;
      }

      $summaryTotal.html(formatPrice(total));
    });
  },

  emptyValues() {
    $otherAddress.find('.custom-select').removeClass('is-disabled');
    $otherAddress.find('input, select').prop('readonly', false).val('');
  },

  emptyMyParcelValues() {
    $myParcelHouseNumber.val('');
    $myParcelPostalCode.val('');
  },

  showSummaryShippingCosts() {
    if (!$summaryDelivery.length) {
      return;
    }

    $summaryDelivery.closest('tr').show();
  },
};

export default shippingSelector;
